import {
    SAVE_RESTAURANTS,
    SELECTED_RESTAURANT,
    ADD_TO_CART,
    SET_TOTAL_PRICE,
    UPDATED_TOTAL_PRICE,
    UPDATED_VARIABLE_PRICE,
    SET_COUPON_AMOUNT,
    SET_TOTALPRICE_WITH_COUPON,
    SET_COUPON_CODE,
    SET_DELIVERY_PRICE,
    SET_UNUSED_BALANCE,
    SET_NEW_BALANCE,
    SET_NEW_RESTAURANT,
    SET_SEL_CITY,
    SET_SEL_RESTAURANT,
    SET_RECENT_ORDERS,
    SET_COUPON_RESULT
} from '../actions/shop';
import Cookies from 'js-cookie';

const initialState = {
    allRestaurants: [],
    selectedRestaurant: null,
    cart: [],
    totalPrice: 0,
    couponAmount: 0,
    totalPriceWithCoupon: 0,
    updatedPrice: 0,
    variablePrice: null,
    couponName: '',
    deliveryPrice: 0,
    // balance: 0,
    theNewBalance: 0,
    setNewRestaurant: null,
    selCityName: null,
    selResName: null,
    recentOrders: [],
    couponResult: null
};

const shop = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_RESTAURANTS :
            return {
                ...state,
                allRestaurants: action.restaurants,
            }
        case SELECTED_RESTAURANT :
            return {
                ...state,
                selectedRestaurant: action.selectRestaurant
            }
        case ADD_TO_CART :
            return {
                ...state,
                cart: action.allCart
            }
        case SET_TOTAL_PRICE :
            const cartItems = [...state.cart];
            let totalPrice = 0;
            cartItems.forEach(cartItem => totalPrice += cartItem.totalPrice);
            Cookies.set('totalPrice', totalPrice);
            return {
                ...state,
                totalPrice,
                updatedPrice: totalPrice
            }
        case UPDATED_TOTAL_PRICE :
            return {
                ...state,
                updatedPrice: action.updatePrice
            }
        case UPDATED_VARIABLE_PRICE :
            return {
                ...state,
                variablePrice: action.variablePrice
            }
        case SET_COUPON_AMOUNT :
            return {
                ...state,
                couponAmount: action.couponAmt
            }
        case SET_TOTALPRICE_WITH_COUPON :
            return {
                ...state,
                couponAmount: action.couponAmtWithPrice
            }
        case SET_COUPON_CODE :
            return {
                ...state,
                couponName: action.couponName
            }
        case SET_DELIVERY_PRICE :
            return {
                ...state,
                deliveryPrice: action.theDeliveryPrice
            }
        case SET_UNUSED_BALANCE:
            return {
                ...state,
                // balance: action.theUnusedBalance
            }
        case SET_NEW_BALANCE:
            return {
                ...state,
                theNewBalance: action.theNewBalance
            }
        case SET_NEW_RESTAURANT:
            return {
                ...state,
                setNewRestaurant: action.theNewRestaurant
            }
        case SET_SEL_CITY:
            return {
                ...state,
                selCityName: action.theCityName
            }
        case SET_SEL_RESTAURANT:
            return {
                ...state,
                selResName: action.theSelRes
            }
        case SET_RECENT_ORDERS:
            return {
                ...state,
                recentOrders: action.allRecentOrders
            }
        case SET_COUPON_RESULT:
            return {
                ...state,
                couponResult: action.theCouponResult
            }
            case "UPDATE_CART_ITEM": {
                const newCart = [...state.cart];
                const item = newCart[action.payload.index];
                const price = item.salePrice || item.price;
              
                newCart[action.payload.index] = {
                  ...item,
                  quantity: action.payload.quantity,
                  totalPrice: action.payload.quantity * price,
                };
              
                return { ...state, cart: newCart };
              }
              
        default:
            return state;
    }

}

export default shop;

